// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter_item[data-v-5eeb95ef]{padding:0 8px 12px!important}", "",{"version":3,"sources":["webpack://./resources/client/modules/leads/components/LeadsFilters.vue"],"names":[],"mappings":"AAGA,8BACE,4BAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.filter_item {\n  padding: 0 8px 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
